import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Calendar, TrendingUp, Settings } from "lucide-react";

interface MealPlanTabsProps {
  defaultTab?: string;
  planTab: React.ReactNode;
  trackingTab: React.ReactNode;
  settingsTab: React.ReactNode;
}

export function MealPlanTabs({ 
  defaultTab = "plan", 
  planTab, 
  trackingTab, 
  settingsTab 
}: MealPlanTabsProps) {
  return (
    <Tabs defaultValue={defaultTab} className="w-full">
      <TabsList className="grid w-full grid-cols-3 mb-6">
        <TabsTrigger value="plan" className="gap-2">
          <Calendar className="h-4 w-4" />
          Plano
        </TabsTrigger>
        <TabsTrigger value="tracking" className="gap-2">
          <TrendingUp className="h-4 w-4" />
          Acompanhamento
        </TabsTrigger>
        <TabsTrigger value="settings" className="gap-2">
          <Settings className="h-4 w-4" />
          Configurações
        </TabsTrigger>
      </TabsList>

      <TabsContent value="plan" className="space-y-4">
        {planTab}
      </TabsContent>

      <TabsContent value="tracking" className="space-y-4">
        {trackingTab}
      </TabsContent>

      <TabsContent value="settings" className="space-y-4">
        {settingsTab}
      </TabsContent>
    </Tabs>
  );
}
